// extracted by mini-css-extract-plugin
export default {"pageWrap":"jc-z","fullWidth":"kc-z","heading":"lc-z","fullBleed":"mc-z","hidden":"nc-z"};